(function () {
  'use strict';

  var popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;

  var STORAGE_KEY = 'newsletter-popup-dismissed-until';
  var SIGNED_UP_KEY = 'newsletter-popup-signed-up';

  function now() {
    return Date.now();
  }

  function shouldShow() {
    if (localStorage.getItem(SIGNED_UP_KEY)) return false;
    var dismissedUntil = localStorage.getItem(STORAGE_KEY);
    if (dismissedUntil && now() < parseInt(dismissedUntil, 10)) return false;
    return true;
  }

  function openPopup() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var frequencyDays = parseInt(popup.getAttribute('data-frequency'), 10) || 7;
    localStorage.setItem(STORAGE_KEY, String(now() + frequencyDays * 24 * 60 * 60 * 1000));
    window.setTimeout(function () {
      popup.hidden = true;
    }, 300);
  }

  if (shouldShow()) {
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    window.setTimeout(openPopup, delay);
  }

  popup.querySelectorAll('[data-newsletter-popup-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  var form = popup.querySelector('.newsletter-popup__form');
  if (form) {
    form.addEventListener('submit', function () {
      localStorage.setItem(SIGNED_UP_KEY, '1');
    });
  }
})();
